import { useTableActionContext } from '@aibees/elephant/context';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { usePageType } from '@aibees/elephant/hooks/use-page-type';
import { ElephantPresetType, SearchTable } from '@aibees/elephant/types';
import { useMemo } from 'react';
import {
  DEFAULT_COMPANY_EXPORT_TEMPLATE,
  DEFAULT_INTEGRATION_EXPORT_TEMPLATE,
  DEFAULT_PEOPLE_EXPORT_TEMPLATE,
} from '../constants';

export function useDefaultTemplateData() {
  const type = useSearchTypeFromRoute();
  const { integrationConfig } = useTableActionContext();
  const { isCompanyPage, isPeoplePage } = usePageType();

  return useMemo(() => {
    const presetTypeMap: Record<SearchTable, ElephantPresetType> = {
      [SearchTable.Company]:
        ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS,
      [SearchTable.People]:
        ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
      [SearchTable.Employees]:
        ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
      [SearchTable.BuyingTeam]: ElephantPresetType.BUYING_TEAM_MATRIX,
    };

    if (integrationConfig) {
      return DEFAULT_INTEGRATION_EXPORT_TEMPLATE;
    }

    if (type) {
      if (
        presetTypeMap[type] ===
        ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS
      ) {
        return DEFAULT_COMPANY_EXPORT_TEMPLATE;
      } else if (
        presetTypeMap[type] ===
        ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS
      ) {
        return DEFAULT_PEOPLE_EXPORT_TEMPLATE;
      }
    }

    // Fallback when type is undefined but page type is known
    if (isCompanyPage) {
      return DEFAULT_COMPANY_EXPORT_TEMPLATE;
    }
    if (isPeoplePage) {
      return DEFAULT_PEOPLE_EXPORT_TEMPLATE;
    }
  }, [integrationConfig, type, isCompanyPage, isPeoplePage]);
}
